import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from "@angular/common/http";
import {Product} from "../../models/product.model";
import {MarketplaceFilters, SearchProductSortType} from "./marketplace.state";

export const fetchProducts = createAction('[Marketplace] Fetch Products');

export const fetchProductsSuccess = createAction('[Marketplace] Fetch Products Success',
    props<{ data: Product[] }>()
);

export const fetchProductsFailure = createAction('[Marketplace] Fetch Products Failure',
    props<{ error: HttpErrorResponse }>()
);

export const setMarketplaceFilters = createAction('[Marketplace] Set Filters',
    props<{ filters: MarketplaceFilters }>()
);

export const setMarketplaceSort = createAction('[Marketplace] Set Sort',
    props<{ sort: SearchProductSortType | null }>()
);

export const toggleMarketplaceShowFilters = createAction('[Marketplace] Toggle Show Filters')

